import { connect, MapStateToProps } from 'react-redux';
import { Link } from '@reach/router';
import React from 'react';

import { getAppTitle } from 'api/Utils';
import { RootState } from 'store/store';

import messages from './Messages';
import {
  MenuDivider,
  MenuItem,
  MenuLink,
  PopoverButton,
  PopoverMenu,
} from './styles';
import Dropdown from 'components/Dropdown';
import Icon from 'components/Icon';
import { getRedirectToLoginPath } from '../../utils/happyFunctions';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import { IUser } from 'store/users/usersType';
import { WithTranslation, withTranslation } from 'react-i18next';

const appTitle = getAppTitle();

const minWidthStyle: React.CSSProperties = {
  minWidth: '100px',
};

type StateToProps = {
  thisUser: IThisUserState;
  user: IUser;
};

type OwnProps = {
  providerId?: number;
  title: string;
};

type ComponentProps = OwnProps & StateToProps & WithTranslation;

const MainNavbar = ({ title, thisUser, user, t }: ComponentProps) => (
  <nav>
    <div className="nav-wrapper">
      <span className="brand-logo center">{messages.getTitle(title)}</span>
      <a
        href="#!"
        className="right hide-on-med-and-down"
        style={{ paddingInlineStart: '20px' }}
      >
        ---{appTitle}
      </a>
      {thisUser.isLoggedIn ? (
        <ul className="left">
          <li>
            <Dropdown
              curveBorder={true}
              marginToTarget={4}
              placement="bottom-start"
              width={130}
              target={
                <PopoverButton>
                  <Icon type="arrow-down" />
                  <span>
                    {thisUser.name || (user && user.name) || t('user')}
                  </span>
                </PopoverButton>
              }
            >
              <PopoverMenu>
                <MenuItem>
                  <MenuLink path="/homepage">
                    <Icon type={'home'} />
                    {t('homeNavbar')}
                  </MenuLink>
                </MenuItem>
                <MenuItem>
                  <MenuLink path="/c/profile">
                    <Icon type={'user'} />
                    {t('profileNavbar')}
                  </MenuLink>
                </MenuItem>
                <MenuDivider />
                <MenuItem>
                  <MenuLink path="/logout">
                    <Icon type={'power'} />
                    {t('exitNavbar')}
                  </MenuLink>
                </MenuItem>
              </PopoverMenu>
            </Dropdown>
          </li>
        </ul>
      ) : (
        <ul className="left" style={minWidthStyle}>
          <li>
            <Link to={getRedirectToLoginPath('personal')}>{t('login')}</Link>
          </li>
        </ul>
      )}
    </div>
  </nav>
);

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state
) => {
  const userId = state.thisUser.userId!;
  const user = state.users.map[userId]!;
  const thisUser = state.thisUser;
  return { thisUser, user };
};

export default connect(mapStateToProps)(
  withTranslation('mainNavBar')(MainNavbar)
);
